import type { MetricResult, RecordBase, SourceRef } from './model';

/** A quoted, immutable assertion from an imported archive revision; never provider verification. */
export interface ArchivePublicationEvidence extends RecordBase {
  logicalId: string;
  publicationId: string;
  contentId: string;
  sourceRef: SourceRef;
  line: number;
  evidence: string;
  account: string;
  channel: string;
  url: string;
  date: string;
  publishedAt: string | null;
  timePrecision: 'day' | 'minute';
  timeNote: string;
  conflicts: string[];
  replacesId: string | null;
  revision: number;
  fingerprint: string;
}

/** UI-transcribed archive values do not prove organic scope or a provider-native window. */
export interface ArchiveMetricReading extends RecordBase {
  logicalId: string;
  publicationId: string;
  publicationEvidenceId: string | null;
  contentId: string;
  campaignId: string;
  sourceRef: SourceRef;
  line: number;
  evidence: string;
  sourceLabel: string;
  collectedAt: string;
  collectionPrecision: 'minute';
  timezone: 'America/Sao_Paulo';
  kind: 'reported_snapshot';
  scope: 'unspecified';
  windowStart: null;
  windowEnd: null;
  windowNote: string;
  coverage: 'partial' | 'reported';
  quality: 'reported';
  method: 'archive_table';
  d7: 'not_claimed';
  publishedAt: string;
  publicationPrecision: 'day' | 'second';
  ageSeconds: number | null;
  metrics: MetricResult[];
  note: string;
  replacesId: string | null;
  revision: number;
  fingerprint: string;
}

export function currentArchiveRecords<T extends { id: string; replacesId: string | null }>(
  rows: T[],
) {
  const replaced = new Set(rows.map((row) => row.replacesId).filter(Boolean));
  return rows.filter((row) => !replaced.has(row.id));
}
